import { selectUser } from './selectUser';
import { TApplicationState } from '../../types/redux';

export const selectUserPhone = (state: TApplicationState) => {
  const user = selectUser(state);
  const phone = user.isAuthenticated && user.phone;

  return phone || null;
};

export const selectUserPhoneConfirmed = (state: TApplicationState) => {
  const user = selectUser(state);
  const phoneConfirmed = user.isAuthenticated && user.phoneConfirmed;

  return phoneConfirmed || null;
};
